// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand-logo[data-v-06cc9f42] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 35px;\n}", ""]);
// Exports
module.exports = exports;
